// First-touch inbound attribution, persisted so a LATER outbound click on the same visit
// still carries the original campaign/source even after the query string is gone (SPA nav).
const KEY = "hs_attr";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

// QA/test sentinel values. QA traffic is tagged with these ON PURPOSE so it can be excluded from
// real analytics at report time. They must NEVER be stored as a visitor's first-touch attribution:
// otherwise a browser that once hit a QA-tagged URL (e.g. a shared or search-indexed QA link) would
// carry QA attribution on every future outbound click and be permanently mis-attributed / filtered
// out of real analytics. Matching is precise so legitimate campaigns (e.g. Google Ads
// utm_source=google&utm_medium=cpc) are never mistaken for QA.
const QA_SOURCES = new Set(["qa", "test", "cowboysnation"]);

export function isQaUtm(u) {
  if (!u) return false;
  const src = (u.utm_source || "").toLowerCase();
  const med = (u.utm_medium || "").toLowerCase();
  const camp = (u.utm_campaign || "").toLowerCase();
  if (QA_SOURCES.has(src) || QA_SOURCES.has(med)) return true;
  if (med === "cbegafe_bhgefbdu") return true;
  if (/^qa[_-]/.test(camp) || /_5359$/.test(camp)) return true;
  return false;
}

function readUtms(search) {
  const sp = new URLSearchParams(search || "");
  const out = {};
  UTM_KEYS.forEach((k) => { const v = sp.get(k); if (v) out[k] = v.slice(0, 200); });
  return out;
}

export function captureAttribution() {
  try {
    const incoming = readUtms(window.location.search);
    // QA/test tags stay request-scoped only — never persisted as a real first-touch identity.
    if (isQaUtm(incoming)) return;
    const existing = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!existing) {
      localStorage.setItem(KEY, JSON.stringify({
        ...incoming,
        landing_referrer: (document.referrer || "").slice(0, 300),
        landing_path: window.location.pathname,
        ts: new Date().toISOString(),
      }));
    } else if (Object.keys(incoming).length && !existing.utm_source) {
      // Upgrade a prior attribution that had no source once a UTM visit arrives (still first real touch).
      localStorage.setItem(KEY, JSON.stringify({ ...existing, ...incoming }));
    }
  } catch (_) { /* localStorage unavailable — attribution simply stays empty */ }
}

export function getAttribution() {
  try {
    const a = JSON.parse(localStorage.getItem(KEY) || "{}");
    // Self-heal a browser previously tainted by a QA-tagged URL before this fix shipped: strip the
    // QA utm_* fields so its real outbound clicks are no longer mis-attributed as QA.
    if (isQaUtm(a)) {
      const cleaned = { ...a };
      UTM_KEYS.forEach((k) => delete cleaned[k]);
      localStorage.setItem(KEY, JSON.stringify(cleaned));
      return cleaned;
    }
    return a;
  } catch (_) { return {}; }
}

// QA/test UTMs present on the CURRENT URL only (request-scoped). Lets an EXPLICIT QA session that is
// actively browsing with QA params keep its QA labels on outbound clicks for analytics exclusion,
// without those labels ever being persisted or leaking to normal visitors.
export function liveQaUtms() {
  try {
    const incoming = readUtms(window.location.search);
    return isQaUtm(incoming) ? incoming : {};
  } catch (_) { return {}; }
}
